import React from "react";
import Review from "./Review";
import listOfReviews from "./listOfReviews";

const Testimonals = () => {
  return (
    <div className="min-h-[200px] pt-4 bg-black flex-col w-screen overflow-hidden max-w-screen-2xl mx-auto">
      <section className=" lg:max-w-screen-2xl mx-auto text-primary p-3 text-3xl  sm:text-5xl xl:text-8xl font-bold  pb-4 h-1/5 flex">
        <h1 className="mx-auto">Testimonials.</h1>
      </section>
      <section className=" pt-4 h-auto w-full overflow-auto flex  mx-auto ">
        {listOfReviews.map((review) => {
          return (
            <Review
              title={review.title}
              content={review.content}
              name={review.name}
              date={review.date}
              business={review.business}
            />
          );
        })}
      </section>
    </div>
  );
};

export default Testimonals;
